export enum SegmentQueryKeys {
    SegmentKey = 'config_SegmentKey',
}